<template>
  <div id="consultation">
    <!--服务咨询-->
    <div class="service-consultation">
      <p class="service-consultation-title">整合行业解决方案，助力业务升级</p>
      <a
        href="javascript:void(0);"
        class="service-consultation-a"
        @click="hClick"
        >服务咨询</a
      >
    </div>
    <!--弹框-->
    <el-dialog
      :lock-scroll="false"
      v-if="dialogVisible"
      title="服务咨询"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="hClose"
    >
      <el-form
        class="dialog"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="labelPosition"
      >
        <el-form-item label="联系人：" prop="username">
          <el-input
            v-model.trim="ruleForm.username"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input
            v-model.number="ruleForm.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input
            v-model.trim="ruleForm.email"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名称：" prop="companyName">
          <el-input
            v-model.trim="ruleForm.companyName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在地：" prop="companyAddr">
          <el-input
            v-model.trim="ruleForm.companyAddr"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题描述：" prop="question">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model.trim="ruleForm.question"
            resize="none"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="success" @click="submitForm" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getServiceConsultation } from "./../../api/index";
export default {
  name: "Consultation",
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      labelPosition: "left",
      ruleForm: {
        username: "",
        phone: "",
        email: "",
        companyName: "",
        companyAddr: "",
        question: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddr: [
          { required: true, message: "请输入所在地", trigger: "blur" },
        ],
        question: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {};
    },
    hClose() {
      // document.body.style.overflow='scroll';
      // document.removeEventListener('touchmove',   e.preventDefault() , false)// 禁止页面滑动
      this.ruleForm = {};
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          getServiceConsultation(this.ruleForm).then(() => {
            alert("发送成功");
            this.dialogVisible = false;
          });
        } else {
          alert("请输入必填项");
          return false;
        }
      });
    },
    hClick() {
      this.dialogVisible = true;
      // document.body.style.overflow='hidden';
      // document.addEventListener('touchmove',   e.preventDefault() , false)// 禁止页面滑动
    },
  },
};
</script>
<style scoped>
/* * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
} */
.noscroll {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
}
.service-consultation {
  width: 100%;
  height: 120px;
  background: url("https://img.deepbaytech.com/images2021/footer.png");
  background-size: 100% 100%;
  text-align: center;
}
.service-consultation-title {
  padding: 22px 0 16px 0;
  font-size: 20px;
  color: #fff;
}
.service-consultation-a {
  display: inline-block;
  font-size: 16px;
  padding: 5px 10px;
  border: 1px solid #fff;
  color: #fff;
  text-decoration: none;
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px 24px 0 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-textarea__inner {
  height: 144px;
  border-radius: 0;
  padding-left: 12px;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-input__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 15px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
::v-deep .el-input__inner {
  width: 240px;
  height: 32px;
  border-radius: 0;
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
#consultation ::v-deep .el-dialog {
  min-width: 570px;
  margin: 0 auto 0px;
}
</style>
